import React, { PropTypes } from 'react';
import ExifReader from 'exifreader';
import ImportarFotosBase from './ImportarFotosBase';
import { prettyAlert } from '../Common/Dialog';

export default class AdicionarImagemAoPonto extends ImportarFotosBase {

	async onDrop(files) {

		this.setState({isProcessing: true});
		var repeatedPicturesInDatabase = [];

		for ( let file of files ) {

			let b = await fetch(file.preview).then(r => r.blob());
			if (b.size > 400 * 1024 * 1024) {
				prettyAlert(`${file.name} grande demais!`, `O limite máximo é de 400 MB por arquivo.`);
				continue;
			}
		
			this.setState({processingFilename: file.name});

			// Gets the hash of file and checks if it is already in database
			var isFileInDatabase = false;
			var filehash = '';
			await this.readFileAsync(file).then(
				(result) => { isFileInDatabase = result.tem_em_documento_no_bd; filehash = result.filehash; }, 
				(error) => { console.error("It failed with " + error); }
			);
			
			if (isFileInDatabase) {
				repeatedPicturesInDatabase.push(file.name);
				continue;
			}

			let datetime = "";
			try {
				const tags = ExifReader.load(await file.arrayBuffer(), {expanded: true, includeUnknown: true});
				datetime = tags.exif.DateTime ? tags.exif.DateTime.description : "";
			} catch (error) {
				console.warn(`Unable to extract exif datetime for ${file.name}. Details: ${error}`);
			}

			this.props.addPointImageWithSrc(this.props.targetPointIndex, file, datetime, filehash);
		}

		if (repeatedPicturesInDatabase.length > 0) {

			this.showAlert(repeatedPicturesInDatabase);
		}

		this.setState({isProcessing: false});
		this.setState({is_lightbox_open: false});
	}

	render () {
		return (
			<div>
				<div className='add-image-point' >
					<a onClick={() => { this.setState({is_lightbox_open: true}); }}>
						<i className="fas fa-plus " />Adicionar Imagem ao Ponto 
					</a>
				</div>

				{super.render()}
			</div>

		);
	}
}

AdicionarImagemAoPonto.propTypes = {
	targetPointIndex: PropTypes.number.isRequired,
	targetPoint: PropTypes.object.isRequired,
	addPointImageWithSrc: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/AdicionarImagemAoPonto.js